import React from 'react';
import { Form } from 'react-bootstrap';
import SubaccountSearchDropdown from '../../../../molecules/SubaccountSearchDropdown/view';
import { formatMoney } from '../../../../../utils/formating';
import './style.css';

function MovementCard({ movement, idx, txs, setReviewPayload, reviewPayload, voucherCandidates, generateDefaultEntryForMovement, companyId }) {
  const amt = Math.abs(Number(movement.amount || 0));
  const isIncome = Number(movement.amount || 0) > 0 || movement.type === 'deposit' || movement.type === 'income';
  const isMatch = movement.matched_to_type === 'match';
  const isLibroNoBanco = movement._source === 'en_libros_no_en_banco';

  return (
    <div className={`card shadow-sm border-start border-4 ${isMatch ? 'border-start-success' : isLibroNoBanco ? 'border-start-warning' : isIncome ? 'border-start-success' : 'border-start-danger'}`}>
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start gap-3 flex-wrap mb-3">
          <div>
            <div className="d-flex align-items-center gap-2">
              {isMatch && <span className="badge bg-success-subtle text-success">✓ Conciliado</span>}
              {isLibroNoBanco && <span className="badge bg-warning-subtle text-warning-emphasis">📕 En Libros</span>}
              {!isMatch && !isLibroNoBanco && (
                <span className={`badge ${isIncome ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`}>
                  {isIncome ? 'Depósito / Ingreso' : 'Retiro / Egreso'}
                </span>
              )}
              {movement.matched_to_type === 'error_registro' && (
                <span className="badge bg-danger-subtle text-danger">⚠ Error</span>
              )}
              <span className="text-muted small">{movement.date || movement.tx_date}</span>
            </div>
            <h6 className="mt-2 mb-1 fw-bold">{movement.description || 'Movimiento sin descripción'}</h6>
            {movement.reference && <span className="text-muted small">Ref: {movement.reference}</span>}
            {isMatch && movement.matched_id && (
              <span className="badge bg-success ms-2">Comprobante #{movement.matched_id}</span>
            )}
          </div>
          <div className="text-end">
            <span className={`h5 fw-bold ${isIncome ? 'text-success' : 'text-danger'}`}>
              {isIncome ? '+' : '-'}{formatMoney(amt)}
            </span>
          </div>
        </div>

        {/* Solo mostrar acciones para movimientos que requieren atención */}
        {!isMatch && (
          <div className="row g-3 pt-2 border-top">
            <div className="col-md-4">
              <Form.Group>
                <Form.Label className="small fw-semibold text-secondary">Acción:</Form.Label>
                <Form.Select size="sm" value={movement.matched_to_type || 'unmatched'} onChange={(e) => {
                  const nt = e.target.value;
                  const targetTxs = txs;
                  const targetIdx = idx;
                  if (targetIdx >= 0 && targetIdx < targetTxs.length) {
                    const nm = [...targetTxs];
                    nm[targetIdx] = {
                      ...nm[targetIdx],
                      matched_to_type: nt,
                      matched_id: null,
                      suggested_entry: nt === 'unmatched'
                        ? generateDefaultEntryForMovement(movement, reviewPayload.bank_account_id)
                        : null
                    };
                    setReviewPayload(prev => ({ ...prev, transactions: nm, movements: nm }));
                  }
                }}>
                  <option value="unmatched">Asiento Automático (Nuevo)</option>
                  <option value="comprobante">Conciliar con Asiento Existente</option>
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-md-8">
              {movement.matched_to_type !== 'comprobante' && movement.suggested_entry?.lines && (
                <div>
                  <Form.Label className="small fw-semibold text-secondary">Líneas del Asiento:</Form.Label>
                  <div className="p-2 rounded border small" style={{ backgroundColor: 'var(--color-gray-5)', borderColor: 'var(--color-gray-20)' }}>
                    {movement.suggested_entry.lines.map((line, lIdx) => {
                      const isBank = (line.account_code || '').startsWith('1110') || (line.account_name || '').toLowerCase().includes('banco');
                      return (
                        <div key={lIdx} className="d-flex justify-content-between align-items-center py-1 border-bottom last-border-0">
                          <div className="flex-grow-1 me-2" style={{ maxWidth: '60%' }}>
                            {isBank
                              ? <span className="fw-semibold text-primary">{line.account_name}</span>
                              : <div className="subaccount-inline-selector">
                                  <SubaccountSearchDropdown selected={{ id: line.account_id, users_accounts_id: line.account_id }} companyId={companyId}
                                    onSelected={(sa) => {
                                      const nm = [...txs];
                                      const ul = [...(movement.suggested_entry.lines || [])];
                                      const code = sa.base_account?.account || '';
                                      const fc = `${code}${String(sa.code ?? '').padStart(2, '0')}`;
                                      ul[lIdx] = { ...ul[lIdx], account_id: sa.id, account_code: fc, account_name: `${fc} - ${sa.description}` };
                                      nm[idx] = { ...nm[idx], suggested_entry: { ...nm[idx].suggested_entry, lines: ul } };
                                      setReviewPayload(prev => ({ ...prev, transactions: nm, movements: nm }));
                                    }} />
                                </div>}
                          </div>
                          <div className="text-end d-flex gap-2">
                            <span className="text-muted" style={{ width: '80px' }}>{line.debit > 0 ? `Db: ${formatMoney(line.debit)}` : ''}</span>
                            <span className="text-muted" style={{ width: '80px' }}>{line.credit > 0 ? `Cr: ${formatMoney(line.credit)}` : ''}</span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {movement.matched_to_type === 'comprobante' && (
                <Form.Group>
                  <Form.Label className="small fw-semibold text-secondary">Línea del Comprobante:</Form.Label>
                  <Form.Select size="sm" value={movement.matched_id || ''} onChange={(e) => {
                    const cId = e.target.value;
                    const candidate = voucherCandidates.find(c => String(c.id) === String(cId));
                    const isCash = (candidate?.account_code || '').startsWith('1105');
                    const nm = [...txs];
                    nm[idx] = { ...nm[idx], matched_id: cId ? Number(cId) : null, potential_error: !!isCash, potential_error_message: isCash ? 'Discrepancia: Movimiento conciliado con caja/efectivo.' : null };
                    setReviewPayload(prev => ({ ...prev, transactions: nm, movements: nm }));
                  }}>
                    <option value="">-- Selecciona el movimiento correspondiente --</option>
                    {voucherCandidates.map(c => (
                      <option key={c.id} value={c.id}>{c.date} | {c.description} | {c.debit > 0 ? `Db: ${formatMoney(c.debit)}` : `Cr: ${formatMoney(c.credit)}`}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}
            </div>
          </div>
        )}
        {(movement.potential_error || movement.potential_error_message) && (
          <div className="alert alert-warning mt-3 mb-0 d-flex align-items-center gap-2 py-2 px-3">
            <span className="h5 mb-0 text-warning">⚠️</span>
            <span className="small text-dark fw-medium">{movement.potential_error_message || 'Posible error de registro.'}</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default function BankStatementReconciliation({
  reviewPayload, setReviewPayload, bankSubaccounts, voucherCandidates,
  handleBankAccountChange, generateDefaultEntryForMovement, companyId
}) {
  const txs = reviewPayload.transactions || reviewPayload.movements || [];
  const rec = reviewPayload._reconciliation;

  // Vista individual: solo transacciones que NO son match +
  // partidas en_libros_no_en_banco del reporte de conciliacion
  const nonMatchTxs = txs.filter(tx => tx.matched_to_type !== 'match');

  const libroNoBancoPartidas = (rec?.partidas_en_libros_no_en_banco || []).map(p => ({
    date: p.tx_date,
    description: p.description,
    amount: p.amount,
    type: 'withdrawal',
    matched_to_type: 'en_libros_no_en_banco',
    suggested_puc: p.suggested_puc,
    suggested_account_name: p.suggested_account_name,
    suggested_entry: p.suggested_entry,
    comprobante_id: p.comprobante_id,
    classification_key: p.classification_key,
    _source: 'en_libros_no_en_banco',
    _tx_hash: p.tx_hash
  }));

  const individualItems = [...nonMatchTxs, ...libroNoBancoPartidas];

  return (
    <div className="review-section">
      {/* Bank Account Selector */}
      <h4>1. Cuenta Bancaria</h4>
      <div className="d-flex align-items-center gap-3 mb-3">
        <Form.Label className="small fw-semibold text-secondary mb-0">Banco a conciliar:</Form.Label>
        <Form.Select style={{ maxWidth: '350px' }} value={reviewPayload.bank_account_id || ''}
          onChange={(e) => handleBankAccountChange(e.target.value)}>
          <option value="">-- Selecciona la cuenta bancaria --</option>
          {bankSubaccounts.map(sub => {
            const code = sub.base_account?.account || '';
            const pc = String(sub.code ?? '').padStart(2, '0');
            return <option key={sub.id} value={sub.id}>{code}{pc} - {sub.description}</option>;
          })}
        </Form.Select>
      </div>

      {/* Reconciliation Summary */}
      {rec && (
        <>
          <h4>Resumen de Conciliación</h4>
          <div className="d-flex flex-wrap gap-2 mb-3">
            <span className="badge bg-success-subtle text-success fs-6 p-2">{rec.matches?.length || 0} Matches</span>
            <span className="badge bg-warning-subtle text-warning-emphasis fs-6 p-2">{rec.partidas_en_libros_no_en_banco?.length || 0} En Libros</span>
            <span className="badge bg-info-subtle text-info-emphasis fs-6 p-2">{rec.grupos_en_banco_no_en_libros?.length || 0} Grupos</span>
            <span className="badge bg-danger-subtle text-danger fs-6 p-2">{rec.errores_de_registro?.length || 0} Errores</span>
          </div>
          <div className="small text-muted mb-3">
            Saldo en Libros: {formatMoney(rec.saldo_en_libros)} |
            Saldo Extracto: {formatMoney(rec.saldo_segun_extracto)} |
            Diferencia: {formatMoney(rec.diferencia)}
            {rec.ecuacion_valida ? <span className="badge bg-success ms-2">✓ Cuadra</span> : <span className="badge bg-danger ms-2">⚠ No cuadra</span>}
          </div>

          {/* Groups */}
          {rec.grupos_en_banco_no_en_libros?.length > 0 && (
            <>
              <h4>2. Grupos de Conciliación</h4>
              <div className="d-flex flex-column gap-3 mt-3">
                {(rec.grupos_en_banco_no_en_libros || []).map((group, gIdx) => (
                  <div key={gIdx} className={`card shadow-sm border-start border-4 ${group.needs_puc_review ? 'border-start-info' : 'border-start-warning'}`}>
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-start flex-wrap gap-2" style={{ cursor: 'pointer' }}
                        onClick={() => { const el = document.getElementById('bgroup-' + gIdx); if (el) el.style.display = el.style.display === 'none' ? '' : 'none'; }}>
                        <div>
                          <div className="d-flex align-items-center gap-2">
                            <span className="fw-bold">{group.label}</span>
                            <span className="badge bg-secondary">{group.count} movs</span>
                            {group.needs_puc_review && <span className="badge bg-info">Revisar PUC</span>}
                          </div>
                          <div className="text-muted small mt-1">
                            {group.suggested_puc && <span className="me-2">PUC: {group.suggested_puc}</span>}
                            {group.suggested_account_name && <span>{group.suggested_account_name}</span>}
                          </div>
                          {group.sample_descriptions?.length > 0 &&
                            <div className="text-muted small mt-1 fst-italic">Ej: {group.sample_descriptions.slice(0, 3).join(' / ')}</div>}
                        </div>
                        <div className="text-end">
                          <span className="h5 fw-bold">{formatMoney(group.total_amount)}</span>
                          <div className="text-muted small">{group.first_date} → {group.last_date}</div>
                        </div>
                      </div>
                      {group.partidas?.length > 0 && (
                        <div id={'bgroup-' + gIdx} style={{ display: 'none' }} className="mt-3 pt-3 border-top small">
                          <div className="text-muted small mb-2 fw-semibold">Transacciones:</div>
                          {group.partidas.map((part, pIdx) => (
                            <div key={pIdx} className="d-flex justify-content-between align-items-center py-1 border-bottom last-border-0">
                              <div><span className="text-muted">{part.tx_date}</span><span className="ms-2">{part.description}</span></div>
                              <span className="fw-semibold text-danger">-{formatMoney(Math.abs(Number(part.amount || 0)))}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Matched Movements */}
          {rec.matches?.length > 0 && (
            <>
              <h4 className="mt-4">3. Movimientos Matcheados ({rec.matches.length})</h4>
              <div className="text-muted small mb-2">Estos movimientos ya coinciden 1:1 con comprobantes contables. No requieren acción.</div>
              <div className="d-flex flex-column gap-2 mt-3" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                {rec.matches.map((m, mIdx) => (
                  <div key={mIdx} className="d-flex justify-content-between align-items-center p-2 rounded border bg-success-subtle">
                    <div><span className="text-muted small">{m.tx_date}</span><span className="ms-2">{m.description}</span></div>
                    <div className="d-flex align-items-center gap-2">
                      <span className="fw-semibold">{formatMoney(Math.abs(Number(m.amount || 0)))}</span>
                      {m.comprobante_id && <span className="badge bg-success">Match #{m.comprobante_id}</span>}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Registration Errors */}
          {rec.errores_de_registro?.length > 0 && (
            <>
              <h4 className="mt-4 text-danger">4. Errores de Registro ({rec.errores_de_registro.length})</h4>
              <div className="d-flex flex-column gap-2 mt-3">
                {rec.errores_de_registro.map((e, eIdx) => (
                  <div key={eIdx} className="d-flex justify-content-between align-items-center p-2 rounded border bg-danger-subtle">
                    <span className="small">{e.description}</span>
                    <span className="fw-semibold text-danger">{formatMoney(Math.abs(Number(e.amount || 0)))}</span>
                  </div>
                ))}
              </div>
            </>
          )}

          <h4 className="mt-4">5. Vista Individual de Movimientos ({individualItems.length})</h4>
          <div className="text-muted small mb-2">Revisar y ajustar cada movimiento que requiere atención.</div>
        </>
      )}
      {!rec && <h4>2. Movimientos del Extracto</h4>}

      {/* Individual Movements */}
      <div className="d-flex flex-column gap-3 mt-3">
        {individualItems.map((movement, idx) => (
          <MovementCard key={movement._tx_hash || `tx-${idx}`}
            movement={movement} idx={idx} txs={txs}
            setReviewPayload={setReviewPayload} reviewPayload={reviewPayload}
            voucherCandidates={voucherCandidates}
            generateDefaultEntryForMovement={generateDefaultEntryForMovement}
            companyId={companyId} />
        ))}
        {individualItems.length === 0 && (
          <div className="text-center text-muted p-4 border rounded" style={{ backgroundColor: 'var(--color-gray-5)', borderColor: 'var(--color-gray-20)' }}>
            {rec ? 'Todos los movimientos están conciliados. Revisa el saldo en libros y cierra la conciliación.' : 'No se encontraron movimientos bancarios en el extracto.'}
          </div>
        )}
      </div>
    </div>
  );
}
